import { HttpProblemDetails } from "@/modules/common";

export function isHttpProblemDetail(arg: any): arg is HttpProblemDetails {
  return Boolean(arg?.type);
}
